import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_this_fac_owned_andor_managed_by_a_woman'

export const dataPointDefinition = {
  retracedId: 'is_this_fac_owned_andor_managed_by_a_woman',
  name: 'Is this facility owned and/or managed by a woman?',
  description:
    'If the facility is owned by a woman (but not managed by a woman) answer Yes.\r\r\nIf the  facility is managed by a woman (but not owned by a woman) answer Yes.\r\r\nIf the  facility is owned and managed by a woman answer Yes.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bui-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 890,
  sectionId: '2.2.5.2',
  impactArea: 'Equality and Diversity',
  impactAreaId: 'EQUALITY_AND_DIVERSITY',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
